'use strict';

// ----------------------------------------
// Imports
// ----------------------------------------

import 'select2';

// ----------------------------------------
// Private
// ----------------------------------------

let $select = $('.select2');
let wrap;
let placeholder;
let $closeBtn = $('.filter-close-btn');

// ----------------------------------------
// Public
// ----------------------------------------

function initSelect () {
	// if(!$select.length) {
	// 	return false;
	// }

	$select.each(function (index) {
		let $this = $(this);
		wrap = $this.closest('.select2-wrap');
		placeholder = $this.data('placeholder');

		$this.select2({
			minimumResultsForSearch: Infinity,
			dropdownParent: wrap,
			placeholder: placeholder,
			width: 'resolve'
		});

		$this.on('select2:select', function () {
			let $container = $this.next('.select2-container');
			let $wrap = $container.closest('.select2-wrap');
			$container.addClass('selected');
			$wrap.addClass('selected');
		});

		$this.on('select2:unselect', function () {
			let $container = $this.next('.select2-container');
			let $wrap = $container.closest('.select2-wrap');
			$container.removeClass('selected');
			$wrap.removeClass('selected');
		});
	});

	$closeBtn.on('click', function () {
		let $parent = $(this).closest('.select2-wrap');
		let $selected = $parent.find($select);
		$selected.val('').trigger('change');
		$selected.trigger('select2:unselect');
	});
}

// ----------------------------------------
// Exports
// ----------------------------------------

export {initSelect};



// WEBPACK FOOTER //
// ./_HTML/src/js/_modules/select.js